import { isEqual } from 'lodash';
import moment, { Moment } from 'moment';
import React, { FC, useEffect, useState } from 'react';
import { DateType } from 'api/models';
import { DatePicker } from 'components/atoms/date-picker';
import { API_DATE_FORMAT } from 'components/atoms/due-date-picker';
import { PLACEHOLDER } from 'components/organisms/task-pane/task-detail/task-fields/task-custom-fields/fields/constant';
import { DateField as DateFieldT } from 'components/organisms/tasks/fields';

interface FieldProps {
  field: DateFieldT;
  onChange?: (selected: DateType | null, field: DateFieldT) => void;
}

export const DateField: FC<FieldProps> = ({ field, onChange }) => {
  const { value } = field;
  const [state, setState] = useState<Moment | null>(null);

  useEffect(() => {
    setState(value ? moment(value) : null);
  }, [value]);

  const commit = (selected: Moment | null) => {
    setState(selected);
    if (onChange && !isEqual(state, value)) {
      onChange(selected ? selected.format(API_DATE_FORMAT) : selected, field);
    }
  };

  return (
    <DatePicker
      value={state}
      placeholder={PLACEHOLDER}
      onChange={commit}
      suffixIcon={null}
      data-cy={`right.content.${field.fieldLabel}`}
    />
  );
};
